










import { Vue, Component, Watch } from 'vue-property-decorator'
import api from 'src/assets/api/gql'
import AttendeeGetResponse from 'src/graphql/attendee/AttendeeGetResponse.gql'
import AttendeeCreateResponse from 'src/graphql/attendee/AttendeeCreateResponse.gql'
import { SessionAttendee } from 'src/graphql/types'

@Component
export default class LayoutsAttendeeSession extends Vue {
  loading = true
  attendee: SessionAttendee | null = null

  async created () {
    this.loading = true
    if (this.$route.params.aid) {
      this.attendee = await this.loadAttendee(this.$route.params.aid)
    } else {
      this.attendee = await this.createAttendee(+this.$route.params.sid)
    }
    if (this.attendee && this.attendee.responseSession && this.attendee.responseTopic) {
      this.$set(this.attendee, 'data', {})
      this.$set(this.attendee.responseTopic, 'data', {})
      this.$set(this.attendee.responseSession, 'data', { result: false, feedback: false, signupCode: null, showSignupCode: false })
      this.$set(this.attendee.responseSession, 'chatMessages', [])
    } else {
      this.exit()
    }
    this.loading = false
  }

  async loadAttendee (id: string) {
    const { data } = await api.query({
      query: AttendeeGetResponse,
      variables: { id }
    })
    return data?.attendeeResponse || null
  }

  async createAttendee (sessionId: number) {
    const { data: { attendeeResponseCreate } } = await api.query({
      query: AttendeeCreateResponse,
      variables: { sessionId }
    })
    return attendeeResponseCreate?.sessionAttendee || null
  }

  exit () {
    this.$router.replace('/attendee/' + (this.attendee?.responseTopic?.id || ''))
  }
}
